export const TABLET = 768;
export const MOBILE = 425;
